<template>
  <div>
    <v-container>
      <v-layout>
        <v-flex offset-xs1 xs10>
          <v-card dark>
            <v-card-title>
              <h2>Students</h2>
              <v-spacer></v-spacer>
              <v-text-field
                append-icon="search"
                label="Search"
                single-line
                hide-details
                v-model="search"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :pagination.sync="pagination"
              :loading="loading"
              light
              :search="search"
              :headers="headers"
              :items="studentsArr"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <tr @click="studentProfile(props.item)" style="cursor:pointer;">
                  <td>{{ props.item.nameFirst }}</td>
                  <td>{{ props.item.nameLast }}</td>
                  <td>{{ props.item.rank }}</td>
                  <td>{{ props.item.ITFnumber }}</td>
                  <td>{{ props.item.dob }}</td>
                  <td>{{ props.item.startDate }}</td>
                  <!-- <td>
                    <v-icon color="primary" @click="studentProfile(props.item)">person</v-icon>
                  </td>-->
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Your search for "{{ search }}" found no results.</v-alert>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Student from "../../../store/models/Student.js";

export default {
  data() {
    return {
      headers: [
        {
          text: "First",
          align: "left",
          value: "nameFirst"
        },
        {
          text: "Last",
          align: "left",
          value: "nameLast"
        },
        {
          text: "Rank",
          align: "left",
          value: "rank"
        },
        {
          text: "ITF Number",
          align: "left",
          value: "ITFnumber"
        },
        {
          text: "DOB",
          align: "left",
          value: "dob"
        },
        {
          text: "Start Date",
          align: "left",
          value: "startDate"
        }
        // {
        //   text: "Profile",
        //   align: "left",
        //   value: "profile"
        // }
      ],
      search: "",
      pagination: {
        sortBy: "nameLast",
        ascending: "true"
      }
    };
  },
  computed: {
    ...mapGetters({
      loading: "getLoading",
      studentsArr: "getStudents"
    })
  },
  methods: {
    studentProfile(student) {
      this.$store.commit("setStudent", student);
      this.$router.push({
        path: "/Students/Profile"
      });
    }
  }
};
</script>

<style>
</style>